<template>
    <div>
        <div class="white-box md:mb-5">
            <transition
                name="opacity"
                mode="out-in"
            >
                <Skeletons v-if="isGettingData" />
                <div
                    v-else
                    class="mb-4"
                >
                    <div class="border-style">
                        <div class="flex justify-between items-center max-width">
                            <label class="text-base xs:text-lg md:text-base text-gray-700 md:text-gray-400">目前保單價值準備金為</label>
                            <div class="text-base xs:text-lg text-gray-700">
                                {{ addComma(showData.valueReserve) }}
                            </div>
                        </div>
                    </div>
                    <div class="border-style">
                        <div class="flex justify-between items-center max-width flex-wrap">
                            <label class="text-base xs:text-lg md:text-base text-gray-700 md:text-gray-400">減少後保單價值準備金為</label>

                            <input
                                v-model.trim="valueReserve"
                                inputmode="numeric"
                                autocomplete="off"
                                maxlength="7"
                                class="input-base w-[11rem] xs:w-[12.5rem] text-right"
                                placeholder="請輸入金額"
                                @input="validValueReserve(valueReserve)"
                            >

                            <div class="flex justify-end w-full">
                                <p class="w-[11rem] xs:w-[12.5rem] error-msg text-right -mb-1 min-h-[0.25rem]">
                                    {{ showData.errorMsg }}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="border-style">
                        <ol class="list-decimal text-base text-gray-700 ml-6 space-y-2">
                            <li style="color: #D44C53;">※提醒您勿聽信高報酬、穩賺不賠等「假投資」之詐騙話術，於接獲來路不明投資管道、網路連結或加 Line 投資時，請至警政署 165 全民防詐網 (https://165.npa.gov.tw/) 進一步查證真實性，遠離詐騙陷阱，守護您與家人的財物安全。</li>
                            <li>提領之保單價值準備金不可低於{{ addComma(showData.rateMin) }}元。</li>
                            <li>減少後剩餘之保單價值準備金不可低於{{ addComma(showData.rateMax) }}元。</li>
                            <li>提領之保單價值準備金最高上限為新台幣100萬元。</li>
                            <li>減少年金保單價值準備金交易完成後之最高可借貸金額若小於已借款本息時，將先行扣除超過之保單借款本息後給付。</li>
                        </ol>
                    </div>
                </div>
            </transition>
        </div>
        <Bottombar>
            <template #right>
                <ButtonNextService
                    v-model:isSubmitOk="isSubmitOk"
                    :disabled="valueReserve===0 || isGettingData"
                    @click="saveAndgoNext"
                />
            </template>
        </Bottombar>
        <Loading :isLoading="isLoading" />
    </div>
</template>

<script>
import { ref, computed, inject } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { addComma } from '@/utils/number/addComma';
import { intMinMax } from '@/utils/rules/customRules';
import { getInfoAB, submitAB } from '@/apis/AB';
import Bottombar from '@/components/layout/Bottombar.vue';
import ButtonNextService from '@/components/buttons/ButtonNextService.vue';
import Loading from '@/components/Loading.vue';
import Skeletons from '@/components/skeletons/Skeletons.vue';
import dialogContnet from '@/json/dialogContent';

export default {
    components: {
        Bottombar,
        Loading,
        ButtonNextService,
        Skeletons,
    },
    setup() {
        const $vfm = inject('$vfm');
        const route = useRoute();
        const { code } = route.meta;
        const store = useStore();
        const isGettingData = ref(false);
        const valueReserve = ref(0);
        const isSubmitOk = ref(false);
        const isLoading = ref(false);
        const result = computed(() => store.state.services.changeItemsResult[code]);

        const showData = ref({
            valueReserve: 0,
            rateMin: 0,
            rateMax: 0,
            totalmax: 1000000,
            errorMsg: '',
        });

        // 取得api資料
        const getData = () => {
            isGettingData.value = true;
            getInfoAB().then((res) => {
                showData.value.valueReserve = res.data.valReserve;
                showData.value.rateMin = res.data.valReserveMin;
                showData.value.rateMax = res.data.downValReserveMin;
                console.log(showData.value);
            }).finally(() => {
                isGettingData.value = false;
            });
        };
        if (!result.value) {
            getData();
        } else {
            const { storeValueReserve, storeShowData } = result.value;
            valueReserve.value = storeValueReserve;
            showData.value = storeShowData;
        }

        const saveAndgoNext = () => {
            console.log(valueReserve.value);
            validValueReserve(valueReserve.value);
            if (showData.value.errorMsg) {
                modalShow(dialogContnet.validateMsg);
                return;
            }
            isLoading.value = true;
            const returnData = {
                valReserve: valueReserve.value,
            };
            submitAB(returnData).then(() => {
                isSubmitOk.value = true;
                const value = {
                    storeShowData: showData.value,
                    storeValueReserve: valueReserve.value,
                };
                store.dispatch('services/setChangeItemsResult', { code, value });
            }).finally(() => {
                isLoading.value = false;
            });
        };
        const validValueReserve = (value) => {
            const { val, errorMessage } = intMinMax({
                value,
                minNum: showData.value.rateMin,
                minMsg: `減少後剩餘之保單價值準備金不可低於${addComma(showData.value.rateMin)}元`,
                maxNum: showData.value.valueReserve,
                maxMsg: '輸入的金額大於目前保單價值準備金',
                type: 2
            });
            showData.value.errorMsg = errorMessage;
            if (showData.value.valueReserve - valueReserve.value > showData.value.totalmax) {
                showData.value.errorMsg = '提領之保單價值準備金最高上限為新台幣100萬元';
            }
            if (showData.value.valueReserve - valueReserve.value < showData.value.rateMax) {
                showData.value.errorMsg = `提領之保單價值準備金不可低於${addComma(showData.value.rateMax)}元`;
            }
            valueReserve.value = val;
        };
        const modalShow = (params) => {
            $vfm.show({
                component: 'DialogBase',
                params,
                on: {
                    confirm() {
                        $vfm.hide('DialogBase');
                    },
                    closed() {
                        $vfm.hide('DialogBase');
                    }
                },
            });
        };
        return {
            isGettingData,
            isLoading,
            isSubmitOk,
            showData,
            valueReserve,
            saveAndgoNext,
            validValueReserve,
            addComma,
        };
    },
};
</script>
<style scoped lang="scss">
.max-width {
    @apply w-full sm:max-w-[30rem] md:max-w-[24rem];
}
.border-style {
    @apply border-t border-dashed border-gray-200 min-h-[3rem] md:min-h-[4.25rem] items-center flex py-2.5 md:py-3.5;
}
</style>
